var React = require('react');

function ListHeader (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)"},[React.createElement("path",{"fill":"#FFF","d":"M19.667 2.133H6V1h14v1.133h-.333zM6.333 10.067H6V8.933h14v1.134H6.333zM19.667 18H6v-1.133h14V18h-.333z","key":0}),React.createElement("circle",{"cx":"1.5","cy":"1.5","r":"1.5","stroke":"#FFF","key":1}),React.createElement("circle",{"cx":"1.5","cy":"9.5","r":"1.5","stroke":"#FFF","key":2}),React.createElement("circle",{"cx":"1.5","cy":"17.5","r":"1.5","stroke":"#FFF","key":3})]));
}

ListHeader.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21"};

module.exports = ListHeader;

ListHeader.default = ListHeader;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/list-header.svg
// module id = 1494
// module chunks = 0